import { computed } from 'vue';
import type { Company } from '@Shared';
import type { Location } from '@Shared';
import { formatPhoneNumber } from '@Shared';

const usePhoneNumber = (
    company: () => Company | null | undefined,
    location?: () => Location | null | undefined,
) => {
    const rawPhone = computed(() =>
        location?.()?.phoneNumbers?.[0] ||
        company()?.phoneNumber ||
        '',
    );

    const formattedPhone = computed(() => formatPhoneNumber(rawPhone.value));

    return { rawPhone, formattedPhone };
};

export default usePhoneNumber;
